import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "reactstrap";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage";
import SearchWatchListEntriesForm from "../../components/search-watch-list-entries-form";
import {
  watchListEntriesSelector,
  watchListEntriesLoadingSelector,
  highRiskCountriesNoEntriesMessageSelector,
} from "../../selectors";
import { notifyWarning } from "../../../../actions";
import WatchListEntriesTable from "../../components/watch-list-entries-table";
import {
  setWatchListEntriesSearchFilters,
  getWatchListEntries,
  clearWatchListEntries,
  deleteWatchListEntry,
} from "../../actions";
import { WATCH_LIST_ENTRY_MESSAGES } from "../../constants/watchListEntryMessages";

import "./watchListEntriesPage.css";
import PageTitle from "../../../../components/common/PageTitle";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import { trimFormData } from "../../../../utilities/filters";

const WatchListEntriesPage = () => {
  const dispatch = useDispatch();
  const watchListEntries = useSelector(watchListEntriesSelector);
  const watchListEntriesIsLoading = useSelector(
    watchListEntriesLoadingSelector
  );

  const noEntriesMessage = useSelector(
    highRiskCountriesNoEntriesMessageSelector
  );

  const [hrcOnly, setHrcOnly] = useState([]);

  const [isSubmited, setIsSubmited] = useState(false);

  useEffect(() => {
    dispatch(getWatchListEntries());
    setIsSubmited(true);

    return () => {
      dispatch(clearWatchListEntries());
    };
  }, []);

  useEffect(() => {
    if (watchListEntries.length > 0 && isSubmited) {
      const getHrcOnly = watchListEntries.filter((c) => c.isHrc);
      setHrcOnly(getHrcOnly);

      if (getHrcOnly.length === 0) {
        dispatch(notifyWarning(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND));
      }
    }
  }, [watchListEntries]);

  const handleSubmit = (data) => {
    const trimmedData = trimFormData(data);
    dispatch(setWatchListEntriesSearchFilters(trimmedData));
    dispatch(getWatchListEntries(trimmedData));
    setIsSubmited(true);
  };

  const handleDelete = (id) => {
    dispatch(getWatchListEntries({}));
    dispatch(deleteWatchListEntry(id));
  };

  return (
    <Container className="hrc-entries col-12 p-0">
      <div className="high-risk-countries-background-logo" />
      <PageTitle title="high-risk countries" className=" border-0 " />
      <FullscreenLoader loading={watchListEntriesIsLoading} />

      <SearchWatchListEntriesForm handleSubmit={handleSubmit} />
      {!watchListEntriesIsLoading ? (
        hrcOnly.length > 0 ? (
          <WatchListEntriesTable
            canEdit={true}
            watchListEntries={hrcOnly}
            handleDelete={handleDelete}
          />
        ) : (
          <NoEntriesMessage payload={noEntriesMessage} />
        )
      ) : null}
    </Container>
  );
};

export default WatchListEntriesPage;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/pages/watch-list-entries-page/WatchListEntriesPage.jsx